import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import commonSr from '@/i18n/sr/common.json';
import episodesSr from '@/i18n/sr/episodes.json';
import equipmentSr from '@/i18n/sr/equipment.json';
import graphicsSr from '@/i18n/sr/graphics.json';
import notificationsSr from '@/i18n/sr/notifications.json';
import plannerSr from '@/i18n/sr/planner.json';
import reportsSr from '@/i18n/sr/reports.json';
import rolesSr from '@/i18n/sr/roles.json';
import showsSr from '@/i18n/sr/shows.json';
import tasksSr from '@/i18n/sr/tasks.json';
import teamSr from '@/i18n/sr/team.json';
import vehiclesSr from '@/i18n/sr/vehicles.json';
import workerSr from '@/i18n/sr/worker.json';
import workflowsSr from '@/i18n/sr/workflows.json';

const resources = {
  sr: {
    common: commonSr,
    equipment: equipmentSr,
    shows: showsSr,
    episodes: episodesSr,
    tasks: tasksSr,
    worker: workerSr,
    workflows: workflowsSr,
    team: teamSr,
    reports: reportsSr,
    roles: rolesSr,
    planner: plannerSr,
    notifications: notificationsSr,
    vehicles: vehiclesSr,
    graphics: graphicsSr,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'sr',
    fallbackLng: 'sr',
    defaultNS: 'common',
    ns: [
      'common',
      'equipment',
      'shows',
      'episodes',
      'tasks',
      'worker',
      'workflows',
      'team',
      'reports',
      'roles',
      'planner',
      'notifications',
      'vehicles',
      'graphics',
    ],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
